import type { GetDynamicPricesResponse } from '@integration/api-client/tariffmanagement';

import { dynamicPricesByDateResponseMock } from './dynamic-prices-by-date-response.mock';

export const dynamicPricesResponseMock: GetDynamicPricesResponse = {
  prices: [
    dynamicPricesByDateResponseMock('2024-04-07'),
    dynamicPricesByDateResponseMock('2024-04-08'),
    dynamicPricesByDateResponseMock('2024-04-09'),
  ],
};
